import {
  Box,
  Card,
  CardContent,
  Grid2,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";
import { Fragment } from "react/jsx-runtime";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ViewIcon from "../../../../../assets/images/icons/view.svg";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import API from "../../../../api/axios";
import moment from "moment";
import HandleInterviewLink, { handleDate } from "../../../../shared/CommonFunctions/CommonFunction";

const breadcrumbs: BreadcrumbsModel[] = [
  {
    name: "Interview Calendar",
    route: "/admin/interview-calendar",
  },
  { name: "Upcoming Interview" },
];

const InterviewCalendarView = () => {
  const navigate = useNavigate();
  const state = useLocation();

  const formatTime = (startTime: any, endTime: any) => {
    if (startTime === "NA") return startTime; // Return "NA" if the time is not available
    return `${moment(startTime, "HH:mm:ss").format("h:mm A")} To ${moment(
      endTime,
      "HH:mm:ss"
    ).format("h:mm A")}`; // Format the time to 12-hour with AM/PM
  };

  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title="Upcoming Interview">
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          onClick={() =>
            navigate("/admin/interview-calendar", { state: state?.state })
          }
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <CardContent sx={{padding: {xs: 0, md: "16px"}}}>
          <Grid2 container spacing={2}>
            <Grid2 size={{xs: 12, sm: 6, md: 3}} marginBottom={4}>
              <Typography variant="body1">Position Title</Typography>
              <Typography variant="subtitle2">
                {state?.state?.calenderData?.position_name || "NA"}
              </Typography>
            </Grid2>
            {/* <Grid2 size={{xs: 12, sm: 6, md: 3}} marginBottom={4}>
              <Typography variant="body1">Level</Typography>
              <Typography variant="subtitle2">04</Typography>
            </Grid2> */}
            <Grid2 size={{xs: 12, sm: 6, md: 3}} marginBottom={4}>
              <Typography variant="body1">Applied Date</Typography>
              <Typography variant="subtitle2">
                {handleDate(state?.state?.calenderData?.application_id?.application_date)}
              </Typography>
            </Grid2>
            <Grid2 size={{xs: 12, sm: 6, md: 3}} marginBottom={4}>
              <Typography variant="body1">Status</Typography>
              <Typography variant="subtitle2">
                {state?.state?.calenderData?.status || "NA"}
              </Typography>
            </Grid2>
            <Grid2 size={{xs: 12, sm: 6, md: 3}} marginBottom={4}>
              <Typography variant="body1">Interview Date</Typography>
              <Typography variant="subtitle2">
                {handleDate(state?.state?.calenderData?.slot_date)}
              </Typography>
            </Grid2>
            <Grid2 size={{xs: 12, sm: 6, md: 3}} marginBottom={4}>
              <Typography variant="body1">Interview Time</Typography>
              <Typography variant="subtitle2">
                {formatTime(
                  state?.state?.calenderData?.start_time || "NA",
                  state?.state?.calenderData?.end_time || "NA"
                )}
              </Typography>
            </Grid2>
            <Grid2 size={{xs: 12, sm: 6, md: 3}} marginBottom={4}>
              <Typography variant="body1">Interview Link</Typography>
              <Typography variant="subtitle2">
                <HandleInterviewLink link={state?.state?.calenderData?.webex_link}/>
              </Typography>
            </Grid2>
          </Grid2>
        </CardContent>
      </Card>
    </PageWrapper>
  );
};
export default InterviewCalendarView;
